// extracted by mini-css-extract-plugin
export default {"container":"CashFlowStatement_container__sBEjk","tableContainer":"CashFlowStatement_tableContainer__Iww7r"};